(function() { window.GUID_08d0f4ba_a1a1_45cc_bd46_5357bf639d56 = { getGuid: function() { return "08d0f4ba-a1a1-45cc-bd46-5357bf639d56"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class GroupList extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                const me = this;
                me.controlId = params[0];
                me.$control = $('#' + params[0]);
            }
            OnDispose() {
                const me = this;
                me.$control.off(`click.${me.controlId}`);
                me.$control.remove();
            }
            OnBindEvents() {
                const me = this;
                me.$control.offon(`click.${me.controlId}`, ".nav-item-container", (e) => {
                    const $target = $(e.target), $itemContainer = $target.closest(".nav-item-container"), url = $itemContainer.data("href");
                    /* ~~~~~~~~~~~~~~
                        Ripple Effect
                        ~~~~~~~~~~~~~~ */
                    //const offset = $itemContainer.offset(),
                    //    x = e.pageX - offset.left,
                    //    y = e.pageY - offset.top,
                    //    w = $itemContainer.width(),
                    //    ripple = document.createElement('span');
                    //ripple.className = 'ripple';
                    //ripple.style.left = x + 'px';
                    //ripple.style.top = y + 'px';
                    //ripple.style.setProperty('--scale', w.toString());
                    //const $ripple = $(ripple);
                    //$itemContainer.append($ripple);
                    //setTimeout(() => {
                    //    $ripple.remove();
                    //}, 500);
                    if (url != null && !$itemContainer.hasClass("no-nav")) {
                        if (typeof url === "string") {
                            if (url.trim() !== "") {
                                CS.Lag(`click.${me.controlId}`, 10, () => {
                                    CS.Nav.Go(url);
                                });
                            }
                        }
                    }
                });
            }
        }
        Controls.GroupList = GroupList;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=group-list.js.map
